// API configuration helper for Redux slices
// This allows consuming applications to configure their API clients

export interface ApiClientConfig {
  // Share modal API methods
  getV1PagesUserList?: (params?: any) => Promise<any>;
  postV1PagesShare?: (data: any) => Promise<any>;
  
  // Header API methods
  getV1Languages?: (params?: any) => Promise<any>;
  
  // Reports title bar API methods
  getV1Company?: (params?: any) => Promise<any>;
  
  // Inventory reports title bar API methods
  getV1InventoryItems?: (params?: any) => Promise<any>;
  getV1WarehouseLocation?: (params?: any) => Promise<any>;
  getV1AssemblyItems?: (params?: any) => Promise<any>;
  getV1BillsOfMaterials?: (params?: any) => Promise<any>;
}

// Helper function to validate API client configuration
export const validateApiClient = (apiClient: ApiClientConfig, requiredMethods: string[]): boolean => {
  for (const method of requiredMethods) {
    if (typeof (apiClient as any)[method] !== 'function') {
      console.warn(`API client missing required method: ${method}`);
      return false;
    }
  }
  return true;
};

// Predefined method groups for different slices
export const API_METHOD_GROUPS = {
  share: ['getV1PagesUserList', 'postV1PagesShare'],
  header: ['getV1Languages'],
  reportsTitleBar: ['getV1Company'],
  inventoryReportsTitleBar: ['getV1InventoryItems', 'getV1WarehouseLocation', 'getV1AssemblyItems', 'getV1BillsOfMaterials'],
} as const;

// Helper to create a configured API client with authentication
export const createConfiguredApiClient = (
  baseApiClient: any,
  getAuthToken: () => any
): ApiClientConfig => {
  const configuredClient: any = {};
  
  // Wrap each API method to include authentication
  Object.keys(baseApiClient).forEach(methodName => {
    if (typeof baseApiClient[methodName] === 'function') {
      configuredClient[methodName] = async (params: any = {}) => {
        const authToken = getAuthToken();
        return baseApiClient[methodName]({ ...authToken, ...params });
      };
    }
  });
  
  return configuredClient;
};